import { useContext } from 'react';

import type { IAppPreviewDispatchContext } from './AppPreviewDispatchContext';
import { AppPreviewDispatchContext } from './AppPreviewDispatchContext';

export const useAppPreviewDispatch = (): IAppPreviewDispatchContext =>
  useContext(AppPreviewDispatchContext);
